import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'support-vtuber-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class SupportVtuberInfoComponent implements OnInit {
  @Input() vtuber: any;
  @Input() currentSupportPlan: any;

  constructor(
      public auth: AuthService
    ) {}

  ngOnInit() {
  }

  alreadySupporting() {
    return this.currentSupportPlan && this.currentSupportPlan.stoppedAt === undefined
  }
}
